export default "__VITE_ASSET__DqkAPJ$J__"